import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/AdminLogin.css';

const BACKEND_URL = 'https://api.comprapapaya.com';

function AdminLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleLogin = async () => {
    if (!username || !password) {
        alert('Completa los campos');
        return;
    }

    try {
            const res = await axios.post(`${BACKEND_URL}/login`, {
            username,
            password
        });
    
            localStorage.setItem('token', res.data.token);
            navigate('/admin');
        } catch (err) {
            alert('Usuario o contraseña incorrectos');
        }
    };

    return (
  <div className="admin-login-container">
    <div className="admin-login-card">
      <h2 className="admin-login-title">Admin Login</h2>
      <p className="admin-login-subtitle">
        Acceso al panel de administración
      </p>

      <div className="admin-login-form">
        <input
          type="text"
          placeholder="Usuario"
          value={username}
          onChange={e => setUsername(e.target.value)}
        />

        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        <button onClick={handleLogin}>
          Ingresar
        </button>
      </div>
    </div>
  </div>
);
}

export default AdminLogin;
